var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  rules: _vm.rules,
                  "label-position": _vm.labelPosition,
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "年份", prop: "year" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "value-format": "yyyy",
                                format: "yyyy",
                                type: "year",
                                placeholder: "选择年",
                              },
                              model: {
                                value: _vm.queryCondition.year,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "year", $$v)
                                },
                                expression: "queryCondition.year",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "季度", prop: "quarter" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                on: { change: _vm.quarterChange },
                                model: {
                                  value: _vm.queryCondition.quarter,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "quarter", $$v)
                                  },
                                  expression: "queryCondition.quarter",
                                },
                              },
                              _vm._l(
                                _vm.quarterOptions,
                                function (item, index) {
                                  return _c("el-option", {
                                    key: index,
                                    attrs: {
                                      label: item.label,
                                      value: item.key,
                                    },
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "月份", prop: "month" } },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { placeholder: "请选择" },
                                model: {
                                  value: _vm.queryCondition.month,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.queryCondition, "month", $$v)
                                  },
                                  expression: "queryCondition.month",
                                },
                              },
                              _vm._l(_vm.monthOptions, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: { label: item.label, value: item.key },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.onExport },
              },
              [_vm._v("导出")]
            ),
          ],
          1
        ),
        _c(
          "el-tabs",
          {
            attrs: { type: "border-card" },
            on: { "tab-click": _vm.handleClick },
            model: {
              value: _vm.activeName,
              callback: function ($$v) {
                _vm.activeName = $$v
              },
              expression: "activeName",
            },
          },
          [
            _c(
              "el-tab-pane",
              { attrs: { label: "QSPI", name: "QSPI" } },
              [
                _c("el-row", [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Supplier"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable1",
                    attrs: {
                      data: _vm.supplierData1,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        width: "50",
                        align: "center",
                        label: "No.",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "评价月",
                        prop: "month",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Category",
                        prop: "category",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Facility Code",
                        prop: "facilityCode",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Facility Name",
                        prop: "facilityName",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Outbound",
                        prop: "outbound",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "140",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "120",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.queryCondition.pageNum,
                        "page-sizes": _vm.pageSizeList,
                        "page-size": _vm.queryCondition.pageSize,
                        layout: _vm.pageLayout,
                        total: _vm.totalCount,
                        "page-count": _vm.pages,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
                _c("el-row", { staticStyle: { "margin-top": "10px" } }, [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Actual Volume"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable2",
                    attrs: {
                      data: _vm.actualVolumeData1,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Grade",
                        prop: "grade",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "DQMP",
                        prop: "dqmp",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Chicken",
                        prop: "rmcChick",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Produce",
                        prop: "rmcProduce",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Antibiotic Chicken",
                        prop: "antiChick",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Total",
                        prop: "total",
                        "min-width": "100",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-row", { staticStyle: { "margin-top": "20px" } }, [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Percentage"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable3",
                    attrs: {
                      data: _vm.percentageData1,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Grade",
                        prop: "grade",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.aaa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.qbr * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.msv * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.swa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.sqms * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.govtCert * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.specComp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.coa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.regComp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(
                                      (scope.row.govtPlant * 100).toPrecision(
                                        12
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.stockRecovery * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.qip * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.feedback * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.sensory * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Consumer Feedback",
                        prop: "consumerFeedback",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.consumerFeedback * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "DQMP",
                        prop: "dqmp",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.dqmp * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Chicken",
                        prop: "rmcChick",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.rmcChick * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Produce",
                        prop: "rmcProduce",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.rmcProduce * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Antibiotic Chicken",
                        prop: "antiChick",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.antiChick * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Total",
                        prop: "total",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.total * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-tab-pane",
              { attrs: { label: "FSQPI", name: "FSQPI" } },
              [
                _c("el-row", [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Supplier"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable1",
                    attrs: {
                      data: _vm.supplierData2,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "index",
                        width: "50",
                        align: "center",
                        label: "No.",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "评价月",
                        prop: "month",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Category",
                        prop: "category",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Facility Code",
                        prop: "facilityCode",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Facility Name",
                        prop: "facilityName",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Outbound",
                        prop: "outbound",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "90",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "140",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "120",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "pagination" },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.queryCondition.pageNum,
                        "page-sizes": _vm.pageSizeList,
                        "page-size": _vm.queryCondition.pageSize,
                        layout: _vm.pageLayout,
                        total: _vm.totalCount,
                        "page-count": _vm.pages,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
                _c("el-row", { staticStyle: { "margin-top": "10px" } }, [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Actual Volume"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable2",
                    attrs: {
                      data: _vm.actualVolumeData2,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Grade",
                        prop: "grade",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "DQMP",
                        prop: "dqmp",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Chicken",
                        prop: "rmcChick",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Produce",
                        prop: "rmcProduce",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Antibiotic Chicken",
                        prop: "antiChick",
                        "min-width": "120",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Total",
                        prop: "total",
                        "min-width": "100",
                      },
                    }),
                  ],
                  1
                ),
                _c("el-row", { staticStyle: { "margin-top": "20px" } }, [
                  _c("div", { staticClass: "title_box" }, [
                    _c("p", { staticClass: "line" }),
                    _c("p", { staticClass: "title" }, [
                      _vm._v("Performance By Percentage"),
                    ]),
                  ]),
                ]),
                _c(
                  "el-table",
                  {
                    ref: "plxTable3",
                    attrs: {
                      data: _vm.percentageData2,
                      "max-height": "500",
                      border: "",
                      "highlight-current-row": "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Grade",
                        prop: "grade",
                        "min-width": "100",
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "AAA",
                        prop: "aaa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.aaa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QBR",
                        prop: "qbr",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.qbr * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "MSV",
                        prop: "msv",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.msv * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SCHR",
                        prop: "swa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.swa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "SQMS",
                        prop: "sqms",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.sqms * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Cert",
                        prop: "govtCert",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.govtCert * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Spec Compliance",
                        prop: "specComp",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.specComp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "COA",
                        prop: "coa",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.coa * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Reg Compliance",
                        prop: "regComp",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.regComp * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov`t Plant Audit",
                        prop: "govtPlant",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    parseFloat(
                                      (scope.row.govtPlant * 100).toPrecision(
                                        12
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Stock Recovery",
                        prop: "stockRecovery",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.stockRecovery * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "QIP",
                        prop: "qip",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.qip * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Product Feedback",
                        prop: "feedback",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.feedback * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Sensory",
                        prop: "sensory",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.sensory * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "DQMP",
                        prop: "dqmp",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.dqmp * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Chicken",
                        prop: "rmcChick",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.rmcChick * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "RMC Produce",
                        prop: "rmcProduce",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.rmcProduce * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Antibiotic Chicken",
                        prop: "antiChick",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.antiChick * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Water safety \n & quality",
                        prop: "waterSafety",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.waterSafety * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "3rd party FS \n Audit/FSPV",
                        prop: "thirdPartyAudit",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.thirdPartyAudit * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov’t audits \n & sampling",
                        prop: "govtAudit",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.govtAudit * 100).toPrecision(
                                          12
                                        )
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Gov’t FS grading",
                        prop: "govtGrading",
                        "min-width": "130",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.govtGrading * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "CSAT Quality",
                        prop: "csatQuality",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.csatQuality * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Customer Feedback - \n Ops",
                        prop: "consumerFeedbackOps",
                        "min-width": "150",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.consumerFeedbackOps * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Customer Feedback - \n SC",
                        prop: "consumerFeedbackSc",
                        "min-width": "150",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (
                                          scope.row.consumerFeedbackSc * 100
                                        ).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        align: "center",
                        label: "Total",
                        prop: "total",
                        "min-width": "100",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    Math.round(
                                      parseFloat(
                                        (scope.row.total * 100).toPrecision(12)
                                      )
                                    )
                                  ) + "%"
                                ),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }